export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_complete_5.560bee30.jpg";